exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "wage-advance{display:block}wage-advance .responsiveMobile .wage-advance{padding:0 0 85px}wage-advance .wage-advance{padding:0 31px}wage-advance .wage-advance wage-advance-form{margin-bottom:34px}wage-advance .wage-advance .remove-events{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/wageAdvance/wageAdvance.scss
// module id = 2109
// module chunks = 0